import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1a0f0f] to-[#2d1810] py-20">
      <div className="container mx-auto px-6 max-w-4xl">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-orange-500 hover:text-orange-400 mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </button>

        <div className="divine-card p-8 md:p-12">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4">
            Privacy Policy
          </h1>
          <p className="text-gray-400 mb-8"><strong>Effective Date:</strong> December 4, 2025</p>

          <div className="space-y-6 text-gray-300 leading-relaxed">
            <p>
              ShraddhaAI ("we", "our", "us") respects your privacy and is committed to protecting your personal information.
            </p>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
              <p className="mb-3">We may collect the following information:</p>

              <h3 className="font-semibold text-white mb-2">a. Personal Information</h3>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
                <li>Name (if provided)</li>
                <li>Email ID / phone number (for login)</li>
                <li>Profile details</li>
              </ul>

              <h3 className="font-semibold text-white mb-2">b. Usage Data</h3>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
                <li>Interactions with AI (chat/voice)</li>
                <li>Time spent in app</li>
                <li>Features used</li>
              </ul>

              <h3 className="font-semibold text-white mb-2">c. Device Information</h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Device type</li>
                <li>OS version</li>
                <li>App version</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">2. How We Use Your Information</h2>
              <p className="mb-3">We use your data to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Provide and improve our services</li>
                <li>Personalize your experience</li>
                <li>Maintain conversation context</li>
                <li>Process subscriptions and payments</li>
                <li>Improve AI responses</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">3. AI & Content Disclaimer</h2>
              <p className="mb-3">
                ShraddhaAI provides AI-generated responses inspired by Hindu scriptures.
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
                <li>The characters (Krishna, Shiva, etc.) are <strong>AI representations based on scriptural references</strong></li>
                <li>They are <strong>not real deities or divine entities</strong></li>
                <li>Responses are generated using trained models referencing publicly available spiritual texts</li>
              </ul>

              <p className="mb-2"><strong>We do NOT claim:</strong></p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Divine authority</li>
                <li>धार्मिक (religious) authenticity</li>
                <li>Absolute correctness of interpretation</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">4. Data Sharing</h2>
              <p className="mb-3">We do <strong>not sell your data</strong>.</p>
              <p className="mb-2">We may share data with:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Payment providers (Razorpay, etc.)</li>
                <li>Analytics tools (Firebase, etc.)</li>
                <li>Cloud infrastructure providers</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">5. Data Storage & Security</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Data is stored securely on cloud servers</li>
                <li>We use industry-standard encryption</li>
                <li>However, no system is 100% secure</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">6. User Rights</h2>
              <p className="mb-2">You may:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Request data deletion</li>
                <li>Opt out of communications</li>
                <li>Contact us for data-related queries</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">7. Children's Privacy</h2>
              <p>
                This app is not intended for users under 13 years of age.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">8. Changes to Policy</h2>
              <p>
                We may update this policy from time to time.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">9. Contact Us</h2>
              <div className="mt-4 p-4 bg-orange-500/10 border border-orange-500/20 rounded-lg">
                <p>Email: <a href="mailto:work.shraddhaai@gmail.com" className="text-orange-500 hover:text-orange-400">work.shraddhaai@gmail.com</a></p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;